export const DeviceType = Object.freeze({
  TracarOBD2: 4,
  TracarWired: 5,
});
